var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UIText',{class:'asb-score',attrs:{"column":"","grow":_vm.grow}},[_vm._v("\n  "+_vm._s(_vm.score)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }